import { Box } from "@mui/material";
import React, { useEffect } from "react";
import styles from "./addDealerForm.module.scss";
import FormikControl from "../../../../components/formComponents/FormikControl";
import i18next from "i18next";
import { useFormikContext } from "formik";
import _ from "lodash";

const CommunicationSection = () => {
  useEffect(() => {
    document.getElementById("addDealerFormWrapper")?.scrollIntoView();
  }, []);

  const formikProps = useFormikContext();
  const handleCopyEmail = (formikProps) => {
    formikProps?.setFieldValue(
      "certificate_Email_Id",
      formikProps.values.email_Id
    )
  }
  return (
    <Box
      className={`formWrapper ${styles.communicationSectionWrapper}`}
      data-testid="CommunicationSection"
    >
      <Box className="textboxDoubleWraper">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Email")}
          id="email_Id"
          name="email_Id"
          placeholder={i18next.t("Email")}
          value={formikProps?.values.email_Id}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("email_Id", false);
            formikProps?.setFieldValue("email_Id", value);
          }}
          error={
            !!(formikProps?.touched.email_Id && formikProps?.errors.email_Id)
          }
          errorMessage={formikProps?.errors?.email_Id}
        />
        <Box
          className={styles.rightArrow}
          onClick={() => handleCopyEmail(formikProps)}
        ></Box>
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("certificate email")}
          id="certificate_Email_Id"
          name="certificate_Email_Id"
          placeholder={i18next.t("certificate email")}
          value={formikProps?.values.certificate_Email_Id}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("certificate_Email_Id", false);
            formikProps?.setFieldValue("certificate_Email_Id", value);
          }}
          error={
            !!(
              formikProps?.touched.certificate_Email_Id &&
              formikProps?.errors.certificate_Email_Id
            )
          }
          errorMessage={formikProps?.errors?.certificate_Email_Id}
        />
      </Box>
      <Box className="textboxDoubleWraper" data-testid="phone">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Phone_Number")}
          id="contact_Number"
          name="contact_Number"
          placeholder={i18next.t("Phone_Number")}
          value={formikProps?.values.contact_Number}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("contact_Number", false);
            formikProps?.setFieldValue("contact_Number", value);
          }}
          error={
            !!(
              formikProps?.touched.contact_Number &&
              formikProps?.errors.contact_Number
            )
          }
          errorMessage={formikProps?.errors?.contact_Number}
        />
      </Box>

      <Box className="textboxThreeItemraper" data-testid="threeitem">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Street_Name")}
          id="street"
          name="street"
          placeholder={i18next.t("Street_Name")}
          value={formikProps?.values.street}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("street", false);
            formikProps?.setFieldValue("street", value);
          }}
          error={!!(formikProps?.touched.street && formikProps?.errors.street)}
          errorMessage={formikProps?.errors?.street}
        />

        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Door_Number")}
          id="house_Number"
          name="house_Number"
          placeholder={i18next.t("Door_Number")}
          value={formikProps?.values.house_Number}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("house_Number", false);
            formikProps?.setFieldValue("house_Number", value);
          }}
          error={
            !!(
              formikProps?.touched.house_Number &&
              formikProps?.errors.house_Number
            )
          }
          errorMessage={formikProps?.errors?.house_Number}
        />

        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Additional (Optional)")}
          id="additional_House_Number"
          name="additional_House_Number"
          placeholder={i18next.t("Additional (Optional)")}
          value={formikProps?.values.additional_House_Number}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("additional_House_Number", false);
            formikProps?.setFieldValue("additional_House_Number", value);
          }}
          error={
            !!(
              formikProps?.touched.additional_House_Number &&
              formikProps?.errors.additional_House_Number
            )
          }
          errorMessage={formikProps?.errors?.additional_House_Number}
        />
      </Box>
      <Box className="textboxDoubleWraper">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Postal_Code")}
          id="postcode"
          name="postcode"
          placeholder={i18next.t("Postal_Code")}
          value={formikProps?.values.postcode}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("postcode", false);
            formikProps?.setFieldValue("postcode", value);
          }}
          error={
            !!(formikProps?.touched.postcode && formikProps?.errors.postcode)
          }
          errorMessage={formikProps?.errors?.postcode}
        />

        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Place")}
          id="city"
          name="city"
          placeholder={i18next.t("Place")}
          value={formikProps?.values.city}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("city", false);
            formikProps?.setFieldValue("city", value);
          }}
          error={!!(formikProps?.touched.city && formikProps?.errors.city)}
          errorMessage={formikProps?.errors?.city}
        />
      </Box>
    </Box>
  );
};
export default CommunicationSection;
